import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['8'],
  paddingBottom: theme.space['22'],
  position: 'relative',
  width: '100%',
}))

export const Label = styled.label(({ theme }) => ({
  color: theme.colors.black800,
  fontSize: '1.4rem',
  fontWeight: 600,
}))

export const Input = styled.input<{ $hasError?: boolean }>(({ theme, $hasError }) => ({
  '&::placeholder': {
    color: theme.colors.black200,
  },
  '&:focus': {
    borderColor: theme.colors.black,
    outline: 'none',
  },
  backgroundColor: $hasError ? theme.colors.visitorParkingErrorBg : theme.colors.gray100,
  border: `${theme.border.size['1']} solid ${
    $hasError ? theme.colors.visitorParkingErrorText : theme.colors.gray500
  }`,
  borderRadius: theme.border.radius['4'],
  color: theme.colors.black800,
  fontSize: '1.6rem',
  fontWeight: 400,
  padding: `${theme.space['10']} ${theme.space['14']}`,
  width: '100%',
}))

export const ErrorMessage = styled.p(({ theme }) => ({
  bottom: 0,
  color: theme.colors.visitorParkingErrorText,
  fontSize: '1.2rem',
  fontWeight: 500,
  left: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  position: 'absolute',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}))

export const ExtraInfo = styled.p(({ theme }) => ({
  bottom: 0,
  color: theme.colors.black500,
  fontSize: '1.2rem',
  fontWeight: 500,
  left: 0,
  position: 'absolute',
}))
